export default __webpack_public_path__ + "static/media/FaceBlonde.1cd3998a.svg";